<template>
  <section>
    <router-link
      v-for="(item, itemIndex) in list"
      :key="itemIndex"
      :to="onRowItemClick(item)"
    >
      <Box>
        <div class="row">
          <div class="col-xs-3">
            {{ item.name }}
          </div>
          <div class="col-xs-3">
            <p>{{ item.publishedDate | HumanDate | IsPublished }}</p>
          </div>
          <div class="col-xs-3">
            <p>{{ item.nextPublishedDate | HumanDate }}</p>
          </div>
          <div class="col-xs-3">
            <p>{{ item.deleted | IsDeleted }}</p>
          </div>
        </div>
      </Box>
    </router-link>
  </section>
</template>

<script>
import Box from './Box.vue';
import HumanDate from '../filters/HumanDate';
import IsPublished from '../filters/IsPublished';
import IsDeleted from '../filters/IsDeleted';

export default {
    name: 'TableRowItems',
    components: { Box },
    filters: { IsDeleted, HumanDate, IsPublished },
    props: {
        list: { type: Array, required: true },
        link: { type: String, required: true },
    },
    methods: {
        onRowItemClick(item) {
            return { name: this.link, params: { id: item.id }, query: { date: window.moment().format('YYYY-MM-DD HH:mm') } };
        },
    },
};
</script>
